import QuestionGeneratorHelper from '../core/question_generator_helper.js'

const icons = {
    '->':           '&#xf178',
    i_pawn:         '&#xf1b0',
    i_pine:         '&#xf1bb',
    i_snow:         '&#xf2dc',
    i_plane:        '&#xe809',
    i_umbrella:     '&#xe808',
    i_flash:        '&#xe80a',
    i_leaf:         '&#xe80c',
    i_key:          '&#xe814',
    i_coffee:       '&#xf0f4',
    i_eye:          '&#xe812',
    i_bell:         '&#xe813',
    i_moon:         '&#xf186',
    i_rocket:       '&#xf135',
    i_anchor:       '&#xf13d',
    i_bug:          '&#xf188',
    i_bomb:         '&#xf1e2',
    i_sun:          '&#xf185',
    i_heart:        '&#xe80e',
    i_black_heart:  '&#xe80f',
    i_star:         '&#xe80d',
    i_black_star:   '&#xe810',
    i_cloud:        '&#xe807',
    i_paperclip:    '&#xe811',
    i_black_flower: '&#xf0a3',
    i_truck:        '&#xe815',
    i_magic:        '&#xf0d0',
    i_puzzle:       '&#xf12e',
    i_car:          '&#xf1b9',
    i_taxi:         '&#xf1ba',
    i_lifebuoy:     '&#xf1cd',
    i_football:     '&#xf1e3',
    i_bike:         '&#xf206',
    i_moto:         '&#xf21c',
    i_bus:          '&#xf207',
    i_subway:       '&#xf239',
    i_train:        '&#xf238',
    i_boat:         '&#xf21a',
    i_diamond:      '&#xf219',
    i_hand:         '&#xf25a',
    i_mouse:        '&#xf245'
}


QuestionGeneratorHelper.textFilters.push(replaceIconNames)


function replaceIconNames (string) {
    string = replaceIconName(string, '->')
    if (string.includes('i_')) {
        for (let name in icons) {
            string = replaceIconName(string, name)
        }
    }
    return string
}


function replaceIconName (string, name) {
    return string.replace(new RegExp(name, 'g'), function () {
        return '<i class="custom_icon">' + icons[name] + ';</i>'
    })
}


export default replaceIconNames

